<template>
  <div class="px-2 py-1">
    <span class="font-medium">{{ item.make_text }}</span> {{ item.model_text }}
  </div>
</template>

<script>
export default {
name: "fleet-column-description-small",
  props: ['column', 'item'],
  methods: { },
}
</script>

<style scoped>

</style>